
import {
    computed,
    defineComponent,
    onMounted,
    reactive,
    ref,
    toRef,
    toRefs,
    watch
} from "vue";
import CigoSlider from "@/components/cigo-ui/unit/form/cigo-slider.vue";
import {
    revertHsvToRGBA,
    toRgbaFunc,
    toRgbaHex,
    toRgbFunc,
    toRgbHex
} from "./utils";

export default defineComponent({
    name: "CigoColorPicker",
    components: {
        CigoSlider
    },
    props: {
        layerData: {
            type: Object,
            default: {}
        }
    },
    setup(props, ctx) {
        let hue = ref(-1);
        let saturation = ref(-0.1);
        let value = ref(-0.1);
        let opacity = ref(1.0);
        let rgbaPanelProxy = reactive({
            r: 0,
            g: 0,
            b: 0,
            a: 0
        });
        let rgbHexPanel = ref("");
        watch(rgbaPanelProxy, newVal => {
            rgbHexPanel.value = toRgbHex(rgbaPanelProxy);
        });
        let rgbaProxy = reactive({
            r: 0,
            g: 0,
            b: 0,
            a: 0
        });
        let rgbHex = ref("");
        let rgbaHex = ref("");
        let rgbFunc = ref("");
        let rgbaFunc = ref("");
        let hexFlag = ref(true);
        watch(rgbaProxy, newVal => {
            rgbHex.value = toRgbHex(rgbaProxy);
            rgbaHex.value = toRgbaHex(rgbaProxy);
            rgbFunc.value = toRgbFunc(rgbaProxy);
            rgbaFunc.value = toRgbaFunc(rgbaProxy);
        });

        let showVal = ref("");
        let showOpacity = toRef(props.layerData, "showOpacity");
        watch(
            [hexFlag, showOpacity, rgbaHex, rgbHex, rgbFunc, rgbaFunc],
            () => {
                if (hexFlag.value) {
                    showVal.value = showOpacity.value ?
                        rgbaHex.value :
                        rgbHex.value;
                } else {
                    showVal.value = showOpacity.value ?
                        rgbaFunc.value :
                        rgbFunc.value;
                }
            }
        );

        let opacitySliderStyle = computed(() => {
            return {
                background: "linear-gradient(to right, " +
                    "rgba(0,0,0,0)" +
                    " 0%, " +
                    rgbFunc.value +
                    " 100%)"
            };
        });
        let opacityBlockStyle = reactive({
            width: "8px",
            height: "25px",
            borderRadius: "2px",
            backgroundColor: "#fff",
            border: "1px solid #e3e3e3",
            boxShadow: "1px 2px 5px #ccc"
        });
        let colorSliderStyle = reactive({});
        let colorBlockStyle = reactive({
            width: "25px",
            height: "8px",
            borderRadius: "2px",
            backgroundColor: "#fff",
            border: "1px solid #e3e3e3",
            boxShadow: "2px 1px 5px #ccc"
        });
        let pointerTmp: any = null;
        let pointerRef = ref(pointerTmp);
        const changeSV = (event: any) => {
            saturation.value =
                Math.round(
                    (Math.min(Math.abs(event.layerX), 280) / 280) * 100
                ) / 100;
            value.value =
                Math.round(
                    (Math.min(Math.abs(event.layerY - 180), 180) / 180) * 100
                ) / 100;
        };

        onMounted(() => {
            saturation.value = 1.0;
            value.value = 1.0;
        });

        watch(hue, newHue => {
            revertHsvToRGBA(rgbaPanelProxy, newHue, 1, 1);
        });
        watch(saturation, newVal => {
            let xPx = 280 * newVal - 3;
            xPx = Math.min(xPx, 277);
            xPx = Math.max(xPx, -3);
            pointerRef.value.style.left = xPx + "px";
        });
        watch(value, newVal => {
            let yPx = 180 * (1 - newVal) - 3;
            yPx = Math.min(yPx, 177);
            yPx = Math.max(yPx, -3);
            pointerRef.value.style.top = yPx + "px";
        });
        watch(
            [hue, saturation, value],
            (
                [newHue, newSaturation, newValue],
                [oldHue, oldSaturation, oldValue]
            ) => {
                //Tips_Flag Vue3.0 watch多个ref对象
                revertHsvToRGBA(rgbaProxy, newHue, newSaturation, newValue);
            }
        );
        watch(opacity, newOpacity => {
            rgbaProxy.a = Math.round(newOpacity * 100) / 100;
        });

        const confirm = () => {
            ctx.emit("notify", "change", showVal.value.toUpperCase());
            ctx.emit("close");
        };
        const cancel = () => {
            ctx.emit("close");
        };

        return {
            showVal,
            hue,
            opacity,
            rgbHexPanel,
            hexFlag,
            changeSV,
            pointerRef,

            opacitySliderStyle,
            opacityBlockStyle,
            colorSliderStyle,
            colorBlockStyle,

            confirm,
            cancel
        };
    }
});
